// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.items {
  display: flex;
  direction: rtl;
  padding: 15px;
}

.item {
  display: flex;
  direction: rtl;
}

.item-label {
  font-size: medium;
  color: blue;
  margin-right: 70px;
}

.item-text {
  margin-right: 10px;
}

.items-date {
  display: flex;
  direction: rtl;
  margin-top: 20px;
  margin-right: 40px;
}

mat-form-field {
  margin-right: 40px;
  margin-left: 10px;
}
mat-form-field mat-label {
  font-size: medium;
  color: blue;
}

.buttons {
  margin-left: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.button-style {
  width: 100px;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/valid-time-setting/valid-time-setting.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/valid-time-setting/valid-time-setting.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,aAAA;ACCJ;;ADEA;EACI,aAAA;EACA,cAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,WAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,kBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,iBAAA;ACCJ;ADCI;EACI,iBAAA;EACA,WAAA;ACCR;;ADGA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,YAAA;ACAJ;;ADGA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACAJ;;ADGA;EACI,aAAA;EACA,YAAA;EACA,aAAA;ACAJ;;ADGA;EACI,eAAA;EACA,iBAAA;ACAJ","sourcesContent":[".items {\r\n    display: flex;\r\n    direction: rtl;\r\n    padding: 15px;\r\n}\r\n\r\n.item {\r\n    display: flex;\r\n    direction: rtl;\r\n}\r\n\r\n.item-label {\r\n    font-size: medium;\r\n    color: blue;\r\n    margin-right: 70px;\r\n}\r\n\r\n.item-text {\r\n    margin-right: 10px;\r\n}\r\n\r\n.items-date {\r\n    display: flex;\r\n    direction: rtl;\r\n    margin-top: 20px;\r\n    margin-right: 40px;\r\n}\r\n\r\nmat-form-field {\r\n    margin-right: 40px;\r\n    margin-left: 10px;\r\n\r\n    mat-label {\r\n        font-size: medium;\r\n        color: blue;\r\n    }\r\n}\r\n\r\n.buttons {\r\n    margin-left: 10px;\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.button-style {\r\n    width: 100px;\r\n}\r\n\r\n.title {\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.parent-both {\r\n    display: flex;\r\n    margin: auto;\r\n    padding: 20px;\r\n}\r\n\r\nmat-icon {\r\n    font-size: 26px;\r\n    margin-left: 10px;\r\n}",".items {\n  display: flex;\n  direction: rtl;\n  padding: 15px;\n}\n\n.item {\n  display: flex;\n  direction: rtl;\n}\n\n.item-label {\n  font-size: medium;\n  color: blue;\n  margin-right: 70px;\n}\n\n.item-text {\n  margin-right: 10px;\n}\n\n.items-date {\n  display: flex;\n  direction: rtl;\n  margin-top: 20px;\n  margin-right: 40px;\n}\n\nmat-form-field {\n  margin-right: 40px;\n  margin-left: 10px;\n}\nmat-form-field mat-label {\n  font-size: medium;\n  color: blue;\n}\n\n.buttons {\n  margin-left: 10px;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n.button-style {\n  width: 100px;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
